import { Component } from '@angular/core';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownAnchor,
} from '@ng-bootstrap/ng-bootstrap';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-button',
  templateUrl: './formly-button.component.html',
  styleUrl: './formly-button.component.scss',
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgbDropdownAnchor,
    FormlyModule,
  ],
})
export class FormlyButtonComponent extends FormlyFieldBaseComponent {
  defaultOptions = {
    props: { type: 'button', btnClass: 'primary' },
  };

  // Accidental double (or 2) clicks fire the action again before the first round
  // trip lands - "Generate Picking List" would create two lists. Same short
  // cooldown as the summary-top action buttons: clicks inside it are ignored,
  // and being time-based it can never dead-lock the button after a failure.
  private static readonly ActionCooldownMs = 800;
  private lastClickAt = 0;

  onClick(event: any) {
    const now = Date.now();
    if (now - this.lastClickAt < FormlyButtonComponent.ActionCooldownMs) {
      return;
    }
    this.lastClickAt = now;

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  onDropdownClick(dropdown: { onClick?: (event: any) => void }, event: any) {
    const now = Date.now();
    if (now - this.lastClickAt < FormlyButtonComponent.ActionCooldownMs) {
      return;
    }
    this.lastClickAt = now;

    dropdown.onClick?.(event);
  }
}
